module.exports = __webpack_public_path__ + "static/img/NG.497d7390.jpg";